import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import AddEditApiAccessKeysDialog from "../apiAccessKey/AddEditApiAccessKeysDialog.js";
const {
  tf,
  tIcon
} = I18N.ns('apiAccessKeyManagement.action.ColumnEditApiAccessKey');
const preparing = {};
export default {
  id: 'apiAccessKeyManagement.action.ColumnEditApiAccessKey',
  type: 'ApiAccessKeys.edit',
  name: tf('name'),
  matches: {
    use: 'postActionsColumnBar',
    client: 'ApiAccessKeys'
  },
  prepare: async context => {
    const {
      item,
      clientProps: {
        delegate,
        allowed,
        dispatch
      }
    } = context;
    if (preparing[delegate.resourceId]) {
      return null;
    }
    preparing[delegate.resourceId] = true;
    const promises = [];
    if (typeof allowed.updateApiAccessKey !== 'boolean') {
      promises.push(dispatch(delegate.apiAccessKey(item.id).canUpdate()));
    }
    if (typeof allowed.assignUserRoles !== 'boolean') {
      promises.push(dispatch(delegate.users().canAssignRoles()));
    }
    return Promise.all(promises).then(() => {
      preparing[delegate.resourceId] = false;
    });
  },
  isPrepared: context => {
    const {
      clientProps: {
        delegate,
        allowed
      }
    } = context;
    if (preparing[delegate.resourceId]) {
      return true;
    }
    return typeof allowed.updateApiAccessKey === 'boolean' && typeof allowed.assignUserRoles === 'boolean';
  },
  handles: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return allowed.updateApiAccessKey === true && allowed.assignUserRoles === true;
  },
  appearance: opts => {
    const icon = tIcon('edit', '@icon:edit');
    return {
      icon,
      variant: 'edit'
    };
  },
  perform: ({
    context
  }) => {
    const {
      item,
      clientProps: {
        projectId,
        actions,
        selectorProps
      },
      emailOptions,
      smsOptions,
      uiName
    } = context;
    Dialogs.show({
      component: AddEditApiAccessKeysDialog,
      props: {
        projectId,
        actions,
        apiAccessKey: item,
        selectorProps,
        emailOptions,
        smsOptions,
        uiName
      }
    });
  }
};